import { TableRow } from '@mui/material';

import { useSegmentProperties } from 'features/common/hooks/useSegmentProperties';

import { SegmentProperties } from './SegmentProperties';
import { NoSegmentSelected, SegmentWrapper, StyledCell } from './shared-ui';

export function SegmentInfo() {
  const segmentProperties = useSegmentProperties();
  if (!segmentProperties) return <NoSegmentSelected />;
  const { cardinalDirection, freeflowSpeed, name } = segmentProperties;

  return (
    <SegmentWrapper>
      <SegmentProperties freeflowSpeed={freeflowSpeed} name={name} />
      {cardinalDirection && (
        <TableRow>
          <StyledCell>Direction</StyledCell>
          <StyledCell>{cardinalDirection}</StyledCell>
        </TableRow>
      )}
    </SegmentWrapper>
  );
}
